import React from 'react';

import { getGoogleMapLink } from '@common/react/components/google/googleUtils';

interface Props extends Omit<React.DetailedHTMLProps<React.AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement>, 'href'> {
	address: string;
}

const GoogleMapLink: React.FC<Props> = ({ address, children, ...props }) => {
	const link = React.useMemo(() => getGoogleMapLink(address), [address]);

	return <a
		target="_blank"
		rel="noreferrer"
		{...props}
		href={link}
	>
		{children}
	</a>;
};

export default GoogleMapLink;
